<div class="container-fluid p-5 pt-3" style="min-height: calc(100vh - 57px) !important">
    <div class="row">
        <div class="col-12 ps-5">
            <div aria-label="breadcrumb" class="text-right float-right">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" routerLink="/home">HOME</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-blue">Centralización Remuneraciones</a></li>
                </ol>
            </div>
        </div>

        <div class="col-12 ps-5">
            <p class="fzas-titulo-componente">Lista de Auditorías</p>
        </div>

        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4">
                        <div class="auditoria-tabs" role="tablist" aria-label="Tipos de auditoría">
                            <button type="button" role="tab" class="auditoria-tab"
                                [class.active]="activeTab === 'centralizacion'"
                                [attr.aria-selected]="activeTab === 'centralizacion'"
                                (click)="cambiarTab('centralizacion')">
                                Auditorías Interna
                            </button>
                            <button type="button" role="tab" class="auditoria-tab"
                                [class.active]="activeTab === 'otic'"
                                [attr.aria-selected]="activeTab === 'otic'"
                                (click)="cambiarTab('otic')">
                                Auditorías SAP
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="container card-container">
                <div class="row">
                    <div class="col px-4 pt-3">
                        <div class="card fzas-card-filtros">
                            <div class="card-body p-4">
                                <form class="row" [formGroup]="filtrosForm" (ngSubmit)="aplicarFiltros()">
                                    <div class="col-12">
                                        <p class="fzas-title-filtros">Buscar Auditoría</p>
                                    </div>

                                    <ng-container *ngIf="activeTab === 'centralizacion'">
                                        <div class="col-12 col-md-6 col-xl-3">
                                            <label for="procNombre" class="form-label fzas-text-input">Nombre Proceso</label>
                                            <input id="procNombre" type="text" formControlName="procNombre"
                                                placeholder="Escribe el nombre del proceso" class="form-control" />
                                        </div>
                                        <div class="col-12 col-md-6 col-xl-3">
                                            <label for="centProcNombre" class="form-label fzas-text-input">Nombre Centro de Proceso</label>
                                            <input id="centProcNombre" type="text" formControlName="centProcNombre"
                                                placeholder="Escribe el nombre del centro" class="form-control" />
                                        </div>
                                    </ng-container>

                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="fechaDesde" class="form-label fzas-text-input">Fecha Desde</label>
                                        <input id="fechaDesde" type="date" formControlName="fechaDesde"
                                            class="form-control" />
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="fechaHasta" class="form-label fzas-text-input">Fecha Hasta</label>
                                        <input id="fechaHasta" type="date" formControlName="fechaHasta"
                                            class="form-control" />
                                    </div>
                                    <div class="col-12 mt-4 d-flex justify-content-end gap-3">
                                        <button type="button" class="btn btn-cancelar-accion"
                                            (click)="limpiarFiltros()">Limpiar Filtros</button>
                                        <button type="submit" class="btn btn-aplicar-accion">Aplicar Filtros</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-4 pt-4">
                        <table *ngIf="activeTab === 'centralizacion'" mat-table [dataSource]="auditorias"
                            style="width: 100%">
                            <ng-container matColumnDef="audId">
                                <th mat-header-cell *matHeaderCellDef class="text-center">ID Auditoría</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">{{ auditoria.audId }}</td>
                            </ng-container>

                            <ng-container matColumnDef="procNombre">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Proceso</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    {{ auditoria.proceso?.procNombre || '-' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="centProcNombre">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Centro</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    {{ auditoria.centroProceso?.centProcNombre || '-' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="audFechaCreacion">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Fecha Creación</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    {{ auditoria.audFechaCreacion | date:'dd/MM/yyyy HH:mm' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="procesoOpciones">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Opciones</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    <div ngbDropdown container="body">
                                        <button type="button" class="btn border-0 btn-opciones" ngbDropdownToggle
                                            aria-label="Opciones de auditoría">
                                            <img src="./assets/icon/opciones-grid.svg" alt="" />
                                        </button>
                                        <div ngbDropdownMenu class="p-0">
                                            <button type="button" class="w-100 py-2 d-flex align-items-center"
                                                ngbDropdownItem (click)="abrirModalVer(
                                                    auditoria.audRespuestaSap,
                                                    auditoria.centroProceso?.centProcNombre,
                                                    auditoria.proceso?.procNombre
                                                )">
                                                <img src="./assets/icon/visualizar.svg" alt="" width="18" class="me-2" />
                                                <span class="fzas-text-dropdownmenu">Visualizar respuesta</span>
                                            </button>
                                            <button type="button" class="w-100 py-2 d-flex align-items-center"
                                                ngbDropdownItem (click)="abrirModalVer(
                                                    auditoria.audPayload,
                                                    auditoria.centroProceso?.centProcNombre,
                                                    auditoria.proceso?.procNombre
                                                )">
                                                <img src="./assets/icon/reabrir.svg" alt="" width="18" class="me-2" />
                                                <span class="fzas-text-dropdownmenu">Visualizar payload</span>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell py-3 text-center" [attr.colspan]="displayedColumns.length">
                                    {{ loading ? 'Cargando auditorías...' : 'No hay auditorías registradas.' }}
                                </td>
                            </tr>
                        </table>

                        <table *ngIf="activeTab === 'otic'" mat-table [dataSource]="auditoriasOtic"
                            style="width: 100%">
                            <ng-container matColumnDef="audId">
                                <th mat-header-cell *matHeaderCellDef class="text-center">ID Auditoría</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">{{ auditoria.audId }}</td>
                            </ng-container>

                            <ng-container matColumnDef="audFechaCreacion">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Fecha Creación</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    {{ auditoria.audFechaCreacion | date:'dd/MM/yyyy HH:mm' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="procesoOpciones">
                                <th mat-header-cell *matHeaderCellDef class="text-center">Opciones</th>
                                <td mat-cell *matCellDef="let auditoria" class="text-center">
                                    <div ngbDropdown container="body">
                                        <button type="button" class="btn border-0 btn-opciones" ngbDropdownToggle
                                            aria-label="Opciones de auditoría OTIC">
                                            <img src="./assets/icon/opciones-grid.svg" alt="" />
                                        </button>
                                        <div ngbDropdownMenu class="p-0">
                                            <button type="button" class="w-100 py-2 d-flex align-items-center"
                                                ngbDropdownItem
                                                (click)="abrirModalOtic(auditoria.audRespuestaSap, auditoria.audId, 'Respuesta SAP')">
                                                <img src="./assets/icon/visualizar.svg" alt="" width="18" class="me-2" />
                                                <span class="fzas-text-dropdownmenu">Visualizar respuesta</span>
                                            </button>
                                            <button type="button" class="w-100 py-2 d-flex align-items-center"
                                                ngbDropdownItem
                                                (click)="abrirModalOtic(auditoria.audPayload, auditoria.audId, 'Payload enviado')">
                                                <img src="./assets/icon/reabrir.svg" alt="" width="18" class="me-2" />
                                                <span class="fzas-text-dropdownmenu">Visualizar payload</span>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="oticDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: oticDisplayedColumns"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell py-3 text-center" [attr.colspan]="oticDisplayedColumns.length">
                                    {{ loading ? 'Cargando auditorías OTIC...' : 'No hay auditorías OTIC registradas.' }}
                                </td>
                            </tr>
                        </table>

                        <mat-paginator [length]="totalRegistros" [pageSize]="limit" [pageIndex]="offset / limit"
                            [pageSizeOptions]="pageSizeOptions" (page)="cambiarPagina($event)"
                            aria-label="Paginación de auditorías">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
